import { useUrlFragmentSync } from './config/use-url-fragment-sync';
import { useUrlHistoryNavigation } from './config/use-url-history-navigation';
import { useUrlNavigation } from './config/use-url-navigation';
import { useUrlOriginReader } from './config/use-url-origin-reader';
import { useUrlPathSync } from './config/use-url-path-sync';
import { useUrlQueryParameterSync, RouteQueryOptions } from './config/use-url-query-parameters-sync';
import { useUrlStateReader } from './config/use-url-state-reader';

export type { RouteNavigate } from './config/use-url-navigation';

type GenericQuery = Record<string, unknown>;

type Props<TQuery extends GenericQuery> = {
  options?: {
    query?: RouteQueryOptions<TQuery>;
  };
};

export function useRouteController<TQuery extends GenericQuery, TState extends object>(
  props?: Props<TQuery>
) {
  const queryOptions = props?.options?.query ?? {};

  const origin = useUrlOriginReader();
  const path = useUrlPathSync();
  const query = useUrlQueryParameterSync(queryOptions);
  const fragment = useUrlFragmentSync();
  const state = useUrlStateReader<TState>();
  const navigate = useUrlNavigation<TQuery, TState>(queryOptions);
  const history = useUrlHistoryNavigation();

  return {
    origin,
    path,
    query,
    fragment,
    navigate,
    state,
    history,
  };
}
